// extracted by mini-css-extract-plugin
export default {"headerBox":"index_headerBox_MgKTV","container":"index_container_Ji0fq","searchBox":"index_searchBox_z2ygc"};